import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { ForgotPasswordRequestSchema } from '../client-sdk/api';

export const useForgotPasswordApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createForgotPassword = useCallback(
    async (data: ForgotPasswordRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.forgotPassword(data);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    createForgotPassword,

    loading,
    error,
  };
};
